import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { TsrctSupplierComment } from '@/generated/gql/graphql';

export interface UseSupplierCommentReturnProps {
  format: (comment: Union.Nullable<TsrctSupplierComment>) => string | null;
}

export const useSupplierComment = (): UseSupplierCommentReturnProps => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SupplierCommentVariant' });
  const format = useCallback(
    (comment: Union.Nullable<TsrctSupplierComment>) => {
      if (!comment) {
        return null;
      }
      return [t(comment.variant), comment.text || null].filter(Boolean).join(' - ');
    },
    [t],
  );
  return { format };
};
